var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.373 12.75l5.17 5.17a.705.705 0 01.22.521.743.743 0 01-.236.532.783.783 0 01-.527.225.699.699 0 01-.527-.225l-6.34-6.34A.829.829 0 014.877 12a.829.829 0 01.256-.633l6.34-6.34a.715.715 0 01.514-.213.748.748 0 01.54.213.735.735 0 01.233.535c0 .2-.078.379-.233.534L7.373 11.25H18.75c.213 0 .391.072.535.215A.726.726 0 0119.5 12a.726.726 0 01-.215.535.726.726 0 01-.535.215H7.373z",
    fill: "currentColor"
  })));
}
SvgBack.displayName = 'Back';
export default SvgBack;